/**
 * @license Copyright (c) 2014-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat'
import AutoImage from '@ckeditor/ckeditor5-image/src/autoimage'
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink'
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote'
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold'
import CKFinderUploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter'
import DataFilter from '@ckeditor/ckeditor5-html-support/src/datafilter'
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials'
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor'
import GeneralHtmlSupport from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupport'
import Heading from '@ckeditor/ckeditor5-heading/src/heading'
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight'
import Image from '@ckeditor/ckeditor5-image/src/image'
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload'
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic'
import Link from '@ckeditor/ckeditor5-link/src/link'
import List from '@ckeditor/ckeditor5-list/src/list'
import Mention from '@ckeditor/ckeditor5-mention/src/mention'
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice'
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat'
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter'
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation'
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline'

/**
 * Custom plugins.
 */
import Collapse from './plugins/collapse/collapse'
import DeleteTable from './plugins/deleteTable/deleteTable'
import Fullscreen from './plugins/fullscreen/fullscreen'

class Editor extends ClassicEditor { }

// Plugins to include in the build.
Editor.builtinPlugins = [
  Autoformat,
  AutoImage,
  AutoLink,
  BlockQuote,
  Bold,
  CKFinderUploadAdapter,
  Collapse,
  DataFilter,
  DeleteTable,
  Essentials,
  FontColor,
  Fullscreen,
  GeneralHtmlSupport,
  Heading,
  Highlight,
  Image,
  ImageUpload,
  Italic,
  Link,
  List,
  Mention,
  Paragraph,
  PasteFromOffice,
  RemoveFormat,
  SimpleUploadAdapter,
  Strikethrough,
  Table,
  TableToolbar,
  TextTransformation,
  Underline,
]

// Editor configuration.
Editor.defaultConfig = {
  fontColor: {
    colors: [
      {
        color: '#FFFFFF',
        label: false,
      },
      {
        color: '#FF224C',
        label: false,
      },
      {
        color: '#FFB722',
        label: false,
      },
      {
        color: '#2FDA77',
        label: false,
      },
      {
        color: '#0055be',
        label: false,
      },
    ],
    documentColors: 0,
  },
  htmlSupport: {
    allow: [
      {
        attributes: {
          'data-user-uuid': true,
        },
      },
    ],
    disallow: [
      {
        name: /.*/,
        styles: {
          'background-color': true,
        },
      },
    ],
  },
  language: 'en-gb',
  table: {
    contentToolbar: [
      'tableColumn',
      'tableRow',
      'mergeTableCells',
      '|',
      'deleteTable',
    ],
  },
  toolbar: {
    items: [
      'collapse',
      'undo',
      'redo',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'link',
      '|',
      'numberedList',
      'bulletedList',
      '|',
      'fullscreen',
      '|',
      'insertTable',
      '|',
      'fontColor',
      'highlight:yellowMarker',
      'RemoveHighlight',
    ],
  },
}

export default Editor
